// Project Imports
import checkIsValueEmpty from "utils/checkIsValueEmpty";

export function isName({ field, validator, }) {
    let defaultMsg = "Please dont use special characters"

    const isEmpty = checkIsValueEmpty(field.value)

    if (isEmpty) {
        return [true, defaultMsg]
    }

    const isAlphabetOnly = validator.isAlpha(field.value, "en-US", { ignore: "." });

    return [isAlphabetOnly, defaultMsg];
}